var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"tm-diag-other"},[_c('i',{staticClass:"-modes"},_vm._l((_vm.modes),function(mode){return _c('i',{key:mode,domProps:{"textContent":_vm._s(mode)}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }